// Example food correlations for demo mode

export const exampleFoodCorrelations = [
  {
    foodItem: 'White Bread',
    symptom: 'Glucose Spike',
    correlation: 0.89,
    timeDelay: '45 minutes',
    confidence: 94,
    occurrences: 12,
    lastOccurrence: '2024-01-14T14:30:00Z',
    glucoseSpike: 68,
    duration: 180
  },
  {
    foodItem: 'Dairy Products',
    symptom: 'Bloating',
    correlation: 0.68,
    timeDelay: '2 hours',
    confidence: 78,
    occurrences: 8,
    lastOccurrence: '2024-01-13T16:00:00Z'
  },
  {
    foodItem: 'Oatmeal (Steel Cut)',
    symptom: 'Stable Glucose',
    correlation: 0.76,
    timeDelay: '30 minutes',
    confidence: 91,
    occurrences: 15,
    lastOccurrence: '2024-01-15T08:00:00Z',
    glucoseSpike: 28,
    duration: 120
  },
  {
    foodItem: 'High Sugar Snacks',
    symptom: 'Mood Changes',
    correlation: 0.61,
    timeDelay: '1 hour',
    confidence: 72,
    occurrences: 15,
    lastOccurrence: '2024-01-12T15:45:00Z',
    glucoseSpike: 95,
    duration: 240
  }
]; 